
import React from "react";
import { Link } from "react-router-dom";
import Logo from "../components/Logo";
import BgPattern from "../components/BgPattern";

const NotFound = () => {
	return (
		<div className="relative bg-[#0b0022] h-full text-white ">
			<BgPattern className="absolute top-0 left-0 w-full h-full opacity-30"></BgPattern>
			<div className=" relative flex  h-full flex-col items-center justify-center p-4 z-[2]">
				<h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-center mb-4">404 - Not Found</h1>
				<p className="font-bold text-center mb-2">Oops! The page you're looking for doesn't exist.</p>
				<div className="h-10"></div>
				<Link to="/" className="bg-[#6100FF]    rounded-md p-2 outline-none focus:border-pink-500 hover:bg-[#4c00cc] text-white text-center text-sm sm:text-base">
					Go to Home
				</Link>

				<Logo className="absolute bottom-0"></Logo>
			</div>
		</div>
	);
};

export default NotFound;


